$(document).ready(function () {
    let anonsCard = $('.card.card-upcoming');
    let eventsModal = $('#modalSingUpEvent');

    if (anonsCard && eventsModal) {
        anonsCard.find('.btn-primary1').on('click', function () {
            let cardUpcoming = $(this).closest('.card.card-upcoming');
            let itemID = cardUpcoming.data('item-room-id');
            if (itemID) {
                let title = cardUpcoming.find('h3').text().trim();
                let date = cardUpcoming.find('.start-date').text().trim();
                let productID = cardUpcoming.data('product-id').trim();

                eventsModal.find('input[name=webinar-name]').val(title);
                eventsModal.find('input[name=webinar-date]').val(date);
                eventsModal.find('input[name=product-id]').val(productID);
            }
        });
    }
});